import React from 'react'
import { useSelector } from 'react-redux'

import { AbstractForm } from '@/components/forms/formik/AbstractForm'

export const TaskOnboardingAgentSelect = ({ handleSubmitOnboarding }) => {
  const { data, loading } = useSelector((state) => state.tasks)

  return (
    <>
      <header className="mb">
        <h2>Choose Your Agents</h2>
        <p>Choose which agents appear in your inbox. You can update this list anytime.</p>
      </header>

      <div className="task-onboarding-agent-select">
        <AbstractForm
          schema={[
            {
              name: 'agents',
              type: 'multiSelect',
              label: 'Agents',
              options: data?.agents,
              loading: loading?.agents,
              fixedWidth: true,
              condenseOptions: false,
              showFullOptions: true,
              placeholder: 'Search for agents',
            },
            {
              name: 'tags',
              type: 'multiSelect',
              label: 'Tags',
              options: data?.tags,
              loading: loading?.tags,
              fixedWidth: true,
              condenseOptions: false,
              showFullOptions: true,
              placeholder: 'Search for tags',
            },
          ]}
          onSubmit={handleSubmitOnboarding}
          buttonLabel="Finish Setup"
          isModal
        />
      </div>
    </>
  )
}
